(function () {
  if (new URLSearchParams(location.search).has('variant')) return;
  document.querySelectorAll('.product-info variant-picker').forEach(function (picker) {
    var sizeSet = Array.prototype.find.call(picker.querySelectorAll('.variant-picker__option'), function (f) {
      return /size|taille|größe|maat|المقاس/i.test((f.querySelector('legend') || {}).textContent || '');
    });
    if (!sizeSet) return;
    var inputs = sizeSet.querySelectorAll('input[type="radio"]');
    if (inputs.length < 2) return;
    var info = picker.closest('.product-info');
    var btn = info && info.querySelector('buy-buttons button[type="submit"]');
    if (!btn) return;
    var original = btn.textContent.trim();
    inputs.forEach(function (i) { i.checked = false; });
    info.classList.add('otb-no-size');
    btn.disabled = true;
    btn.textContent = 'Select a size';
    sizeSet.addEventListener('change', function () {
      info.classList.remove('otb-no-size');
      btn.disabled = false;
      if (btn.textContent.trim() === 'Select a size') btn.textContent = original;
    }, { once: true });
  });
})();